import styled, { css } from 'styled-components';
import Markdown from 'react-markdown';
import { ContentContainer } from '../layout/layout.styles';
import { Card } from '../expandableCard/expandableCard.styles'
import { media } from '../../utils/media';


export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33em;
  letter-spacing: 0.45px;
  flex: 1 auto;
  margin: 0 20px 0 0;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color};
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0 0;
  ${media.tablet`
    flex-direction: row;
    gap: 20px;
  `}
`;

export const Container = styled(ContentContainer)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 45px auto 60px;
  ${Card} {
    min-width: calc((100% - 80px) / 3);
    padding: 30px;
  }
`;